import services from './module';
import {AnimatronSvc} from 'services/AnimatronSvc';
import {HttpSvcFactory} from './HttpSvc';

export class AnimatronUsersSvc extends AnimatronSvc<anm.User> {
    keyword: string;

    constructor(keyword: string, query: ProjectSearchCriteria = {}, secure = false) {
        super(query, secure);
        this.keyword = encodeURIComponent(keyword);
        this.setSecure(secure);
    }

    makeHttpSvc() {
        return this.HttpSvc('profile', 'search', this.keyword).get;
    }
}
function AnimatronUsersSvcFactory($rootScope: ng.IRootScopeService,
                                  $log: ng.ILogService,
                                  $timeout: ng.ITimeoutService,
                                  $q: ng.IQService,
                                  $stateParams: any,
                                  HttpSvc: HttpSvcFactory) {
    _.extend(AnimatronUsersSvc.prototype, {
        $rootScope, $log, $timeout, $q, $stateParams, HttpSvc
    });
    return AnimatronUsersSvc;
}

export type AnimatronUsersFactory = new(keyword: string,
                                        query: ProjectSearchCriteria,
                                        secure?: boolean) => AnimatronUsersSvc;

services.factory('AnimatronUsers', AnimatronUsersSvcFactory);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/AnimatronUsersSvc.ts